import { isLeft } from "fp-ts/lib/These";
import { inject } from "mobx-react";

import type { LinkedItemRecordFragment } from "@ihr-radioedit/inferno-webapi";
import { trimText } from "../../../../core/lib/utilities";
import { getPaths } from "@ihr-radioedit/inferno-core";
import { ILog } from "@ihr-radioedit/inferno-core";
import { reverseRoute } from "@inferno/renderer-shared-core";
import { zonedTimeFormat } from "@inferno/renderer-shared-core";
import { Heading, MagicLink } from "../../../../core/ui";
import { CoastShowPayloadResolver } from "./CoastContent.types";
import type { Store } from "@inferno/renderer-shared-core";

const log = ILog.logger("CoastGuestPastShowItem");

interface CoastGuestPastShowItemProps {
  show: LinkedItemRecordFragment;
  store?: Store;
}

export const CoastGuestPastShowItem = inject("store")(({ show, store }: CoastGuestPastShowItemProps) => {
  if (!store) {
    return null;
  }

  const { summary, slug, payload } = show;

  const resolvedPayload = CoastShowPayloadResolver.decode(payload);

  if (isLeft(resolvedPayload)) {
    log.error(`Payload failed validation: ${getPaths(resolvedPayload)}`);
    return null;
  }

  const { fields } = resolvedPayload.right;

  const timezone = store.site.index.timeZone || store.env.DEFAULT_TIMEZONE;

  const formattedShowDate =
    fields.show_date?.value &&
    zonedTimeFormat({ date: fields.show_date.value, timezone, outputFormat: "EEEE - MMMM d yyyy" });

  const showUrl = reverseRoute(store.site, "shows_detail", { slug }) || "#";

  return (
    <li key={show.ref_id}>
      <Heading level={4}>
        <MagicLink external={true} to={showUrl} context={slug}>
          {summary.title}
        </MagicLink>
      </Heading>
      <time>{formattedShowDate}</time>
      <section className="item-summary">
        {trimText(summary.description, 280)}
        <MagicLink external={true} to={showUrl} context={slug} className="more-link">
          More &raquo;
        </MagicLink>
      </section>
    </li>
  );
});
